import { useEffect, useState } from 'react';
import { auth } from './supabase';

// Shared session + role hook. role: null (anon) | 'customer' | 'staff' | 'admin'
export function useAuth() {
  const [state, setState] = useState({ loading: true, session: null, role: null, fullName: '' });

  useEffect(() => {
    let alive = true;
    const load = () =>
      auth.getRole().then((r) => {
        if (alive) setState({ loading: false, ...r });
      }).catch(() => {
        if (alive) setState({ loading: false, session: null, role: null, fullName: '' });
      });
    load();
    const { data: sub } = auth.onChange(() => load());
    return () => {
      alive = false;
      sub?.subscription?.unsubscribe();
    };
  }, []);

  return { ...state, isStaff: state.role === 'staff' || state.role === 'admin' };
}
